<template>
  <component :is="layout">
    <slot />
  </component>
</template>

<script setup lang="ts">
import {
  LayoutWeb,
  LayoutWidget,
  LayoutBot,
  LayoutBookApp
} from '#components'

useSiteHead()


const layoutStore = useLayoutStore()

const layout = computed(() => {
  switch(layoutStore.layout) {
    case 'bot':
      return LayoutBot
    case 'facebook':
      return LayoutWidget
    case 'widget':
      return LayoutWidget
    case 'app':
      return LayoutBookApp
    default:
      return LayoutWeb
  }
})
</script>

